import { FetchAPI, ParamsSerializer } from './auth-service';
import {
    cloneDeep as _cloneDeep,
    has as _has,
} from 'lodash';

const fields = [
    {
        variable: 'indicator',
        hidden: false,
        headerName: 'Field Indicator',
        field: 'indicator',
        type: 'string',
    },
    {
        variable: 'indicator_type',
        hidden: false,
        headerName: 'Indicator Type',
        field: 'indicator_type',
        defaultSort: 'asc',
        type: 'string',
    },
    {
        variable: 'ti_source',
        hidden: false,
        headerName: 'Source',
        field: 'ti_source',
        type: 'string',
    },
    {
        variable: 'filename',
        hidden: false,
        headerName: 'Filename',
        field: 'filename',
        type: 'string',
    },
    {
        variable: 'meta.desc',
        hidden: false,
        headerName: 'Description',
        field: 'meta.desc',
        type: 'string',
    },
    {
        variable: 'meta.if_in',
        hidden: false,
        headerName: 'if in',
        field: 'meta.if_in',
        type: 'string',
    },
    // {
    //     variable: 'meta.do_notice',
    //     hidden: false,
    //     headerName: 'Do Notice',
    //     field: 'meta.do_notice',
    //     type: 'string',
    // },
    {
        variable: 'created',
        hidden: false,
        headerName: 'Created',
        field: 'created',
        type: 'string',
    },
    {
        variable: 'updated',
        hidden: false,
        headerName: 'Updated',
        field: 'updated',
        type: 'string',
    },
    {
        variable: 'enabled',
        hidden: false,
        headerName: 'Enabled',
        fields: 'enabled',
        type: 'string',
    },
    {
        variable: 'actions',
        hidden: false,
        headerName: '',
        fields: 'actions',
        type: 'string',
    }
];

const MC2CHECK = (process.env.BRICATA_APPLIANCE_TYPE === 'mc2');

class TIDataService {
    constructor () {
        // we only need one of these
        if (!TIDataService.instance) {
            TIDataService.instance = this;
        }
        this.searchPlaceholder = 'Search Threat Intel';
        this.fields = fields;

        this.getTI = (query) => {
            const q = { ...query };
            let s;
            if (query.selector) {
                s = q.selector;
                delete q.selector;
            }
            return FetchAPI({
                method: 'GET',
                url: `/ti/zeek/indicators?${ParamsSerializer(q)}`,
                body: s,
            });
        };

        this.getIndicator = (query) => {
            return FetchAPI({
                method: 'GET',
                url: `/ti/zeek/indicators?${ParamsSerializer(query)}`,
            });
        };

        this.searchTI = (query, body) => {
            return FetchAPI({
                method: 'GET',
                url: `/ti/zeek/indicators?${ParamsSerializer(query)}`,
                body: body,
            }).then(res => {
                if (!res) res = { objects: [] };
                self.asof = res.timestamp;
                this.data = res.objects || [];

                return {
                    data: this.data,
                    page: query ? query.page : 1,
                    totalCount: this.total || (res.objects || []).length,
                };
            });
        };

        this.updateTI = (body) => {
            return FetchAPI({
                method: 'POST',
                url: 'ti/zeek/indicators',
                body: body
            });
        };

        this.deleteTI = (body) => {
            return FetchAPI({
                method: 'DELETE',
                url: 'ti/zeek/indicators',
                body: body,
            });
        };

        this.importTI = (query) => {
            return FetchAPI({
                method: 'POST',
                url: `/ti/zeek/indicators/-import?${ParamsSerializer(query)}`,
            });
        };

        this.importAllIndicators = () => {
            return FetchAPI({
                url: '/ti/zeek/indicators/all/-import',
                method: 'POST',
            });
        };

        this.getNextTISync = () => {
            return FetchAPI({
                url: 'ti/zeek/indicators/-next',
                method: 'GET',
            });
        };

        this.manuallyKickImport = () => {
            return FetchAPI({
                url: '/ti/zeek/indicators/-kick',
                method: 'POST',
            });
        };

        this.manuallyKillImport = () => {
            return FetchAPI({
                url: '/ti/zeek/indicators/-sync',
                method: 'DELETE',
            });
        };

        // Discard shadow policy
        this.deleteShadowPolicy = (policy) => {
            return FetchAPI({
                method: 'DELETE',
                url: `ti/policy/zeek/indicators/shadow/${policy}`,
            });
        };

        // Does a shadow policy exist?
        this.checkShadowPolicy = (policy) => {
            return FetchAPI({
                method: 'GET',
                url: `ti/policy/zeek/indicators/shadow/${policy}/-query`,
            });
        };

        // Create a shadow policy
        this.createShadowPolicy = (policy) => {
            return FetchAPI({
                method: 'POST',
                url: `ti/policy/zeek/indicators/shadow/${policy}/`,
            });
        };

        // Get a shadow policy after check
        this.getShadowPolicy = (policy, uuid, filter) => {
            const f = _cloneDeep(filter);
            if (_has(f, 'selector')) {
                delete f.selector;
            }
            return FetchAPI({
                method: 'PUT',
                url: `ti/policy/zeek/indicators/shadow/${policy}/${uuid}/-read?${ParamsSerializer(f)}`,
                body: filter.selector,
            });
        };

        // Update a shadow policy
        this.updateShadowPolicy = (policy, uuid, updater) => {
            return FetchAPI({
                method: 'POST',
                url: `ti/policy/zeek/indicators/shadow/${policy}/${uuid}`,
                body: updater,
            });
        };

        // Save the shadow policy as a policy and discard shadow
        this.saveShadowPolicy = (policy, sensors, uuid) => {
            const url = MC2CHECK
                ? `mc2/policies/update-assign/zeek_indicators/${policy}`
                : `sensors/groups/zeek_indicators/${policy}/-update-assign`;
            return FetchAPI({
                method: 'PUT',
                url,
                body: {
                    sensors,
                    data: { uuid },
                }
            });
        };

        // Get the policies that have this indicator enabled
        // looks like I messed up with the json UUID field being uppercase
        this.GetIndicatorEnabledPolicies = (d) => {
            return FetchAPI({
                url: `ti/policy/zeek/indicator/${d.UUID}/policies`,
                method: 'GET'
            });
        };

        this.getSavedSearches = () => {
            try {
                let searches = localStorage.getItem('savedSearches_ti') || '[]';
                if (searches.length < 1) searches = '[]';
                return JSON.parse(searches);
            } catch (err) {
                console.error('getSavedSearches error', err);
                return [];
            }
        };

        this.saveSearch = (str) => {
            if (!str || !str.length) return;
            const searches = this.getSavedSearches();
            const i = searches.findIndex(s => s === str);
            if (i >= 0) searches.splice(i, 1);
            searches.unshift(str);
            searches.splice(5);
            localStorage.setItem('savedSearches_ti', JSON.stringify(searches));
        };

        this.getConf = () => {
            return FetchAPI({
                url: 'ti/zeek/indicators/config',
                method: 'GET',
            });
        };

        this.updateConf = conf => {
            return FetchAPI({
                url: 'ti/zeek/indicators/config',
                method: 'POST',
                body: conf,
            });
        };

        return TIDataService.instance;
    }
}

const TIService = new TIDataService();

export {
    TIService as default,
    fields as tiFields,
};
